import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import { useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';

import { TIFFViewer } from 'react-tiff';
//import 'react-tiff/dist/index.css';

export default function EmbryoImage(props: any) {
    const { imgItem } = props;
    let img: string | undefined = undefined;
    let download: string | undefined = undefined;
    let thumb: string | undefined = undefined;
    if (imgItem['file_data']){
    img = imgItem['file_data']['filename'];
    download = imgItem['file_data']['filename'];
    thumb = imgItem['file_data']['thumbnail'];
  }
    //tmp fix for sections link
    if(imgItem["sections_link"] != null) {
      imgItem["sections_link"] = imgItem["sections_link"].replace("https://enhancer", "https://vista-enhancer");
    }

    const [imageModalopen, setImageModalopen] = useState<any>(false);
    const handleImageModalOpen = () => {
        setImageModalopen(true);
      };
  
  
      const handleImageModalClose = () => {
        setImageModalopen(false);
      };

  /**
   * 
   * Functions using the NEW mouse.lbl.gov image API.
   * 
   */

    const imageBoxDisplayApi = () => {
        if(!imgItem || !img)
          return null;
        
        let ext = img;
        ext = ext[ext.length -1];
        if(ext === "tif"|| ext === "tiff") {
          return(
            <TIFFViewer 
            tiff={img}
            />
          )
        }
        else {
          return(
            <img src={img} alt='' width='500'/>
          )
        }
      };

    const imageViewer = () => {
      if(!imgItem || !img)
        return null;

      let title = "Embryo: " + imgItem.exp_embryo + ", Position: " + imgItem.image;
      if(imgItem.is_blue !== "TRUE" && imgItem.is_blue !== 1)
        title += ", Staining: No";
      return(
        <Dialog open={imageModalopen} onClose={handleImageModalClose}>
            <DialogTitle sx={{ m: 0, p: 2 }}>
           {title}
           <IconButton 
                  aria-label="close"
                  onClick={handleImageModalClose}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton> 
            </DialogTitle>
            <DialogContent>
            {/*<img src={img} alt='' width='500'/>*/}
            {imageBoxDisplayApi()}
            </DialogContent>
            <div className='row mx-1'>
            <div className='col-sm-6 text-left' style={{"fontSize":"12px"}}>{(imgItem.sections_link !== null)?<div>
              <a href={imgItem.sections_link} target='_blank' rel='noreferrer' className='text-decoration-none btn btn-sm btn-primary'>View Corresponding Sections</a>
            </div>:<></>}</div>
            <div className='col-sm-6 text-end '>
            <a href={download} rel='noreferrer' className='btn' ><DownloadIcon/></a>
            </div>
            </div>
        </Dialog>
    )
    }


    const embryoImageHandler = () => {

      let subtitle = "Pos: "+ imgItem.image;
      if(imgItem.is_blue !== "TRUE" && imgItem.is_blue !== 1) {
        subtitle += ", Staining: No";
      }
      var str_embryo = "Embryo: " + imgItem.exp_embryo;
      var url = thumb;             
    
      return (
          <div style={{display:"inline-block", margin:"5px", textAlign:"center", verticalAlign:"top"}}>
                      {str_embryo}  <br/>
                      <i>{subtitle}</i> <br/>
                      {(imgItem.sections_link !== null && imgItem.sections_link !== "")?
                <a href={imgItem.sections_link} target='_blank' rel='noreferrer' className='text-decoration-none' style={{fontSize:"12px"}}>[Sections]</a>
              :<></>}
                      <br/>
                      <button onClick={(event)=>handleImageModalOpen()} style={{border:"0px", padding:"0px"}}><img src={url} width="120" alt={"Embryo No. "+imgItem.exp_embryo}/></button>
                     {imageViewer()}
                  </div>
      );
    };

    

    if(!imgItem || !img)
        return null;
    return(
      embryoImageHandler()
    )
}